// InfoContent.jsx
import React, { useEffect, useRef } from 'react';

const InfoContent = ({
  id,
  infoField,
  showInfo,
  hideInfo,
  infoText,
  context = "default", 
  buttonStyle = {},
  contentStyle = {},
  buttonClassName = "",
  contentClassName = "",
  showButton = true,
  ariaLabelShow,
  ariaLabelHide
}) => {
  const isActive = infoField === id;
  const containerRef = useRef(null);
  const [isHovered, setIsHovered] = React.useState(false);
  const contextStyles = {
    step1_checkbox: {
      button: { top: '15px' },
      content: { top: '17px',marginRight:2 }
    },

    step1_textarea: {
      button: { top: '2px', marginTop: 20 },
      content: { margin: '-60px 22px 0 0' }
    },
    //sections destinataire
    step1_destinataire: {
      button: { marginTop: 9 },
      content: { top: '15px' }
    },
    modal:{
      content: { margin: '-25px -17px 0 0' }
    },
    email:{
      button: { marginTop: -12 },
    },
    emailStep2:{
      button: { marginTop: -14,marginRight:-2 },
    },
    taxId:{
      content: { marginTop: 3,marginRight:2 },
    },
    emailModalUpdate:{
      content: { marginTop: -26,marginRight:-16 },
    },
    ikeaFamily:{
      content: { marginTop: 3,marginRight:2 },
    },
    default: {
      button: {},
      content: {}
    },
    
  };

  const selectedStyles = contextStyles[context] || contextStyles.default;
  
  const finalButtonStyle = { ...selectedStyles.button, ...buttonStyle };
  const finalContentStyle = { ...selectedStyles.content, ...contentStyle };

  return (
    <div ref={containerRef} className="infoContentContainer">
      {showButton && (
        <button
        type="button"
        className={`info ${buttonClassName} ${isHovered ? 'is-hovered' : ''}`}
        style={{
          backgroundColor: "#E5E5E5",
          borderWidth: 0,
          ...finalButtonStyle
        }}
      
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      
        onFocus={() => showInfo(id)}
        onBlur={() => hideInfo()}
      
        onClick={() => {
          if (isActive) hideInfo();
          else showInfo(id);
        }}
      
        onKeyDown={(e) => {
          if (e.key === 'Escape') hideInfo();
        }}
      
        aria-expanded={isActive}
        aria-describedby={isActive ? id : undefined}
        aria-label={isActive ? ariaLabelHide : ariaLabelShow}
      >
      </button>
      
      )}
      <div
        id={id}
        style={finalContentStyle}
        className={`infoContent ${contentClassName} ${isActive ? 'show' : ''}`}
        role="tooltip"
        aria-hidden={!isActive}
      >
        {typeof infoText === 'string' ? <p>{infoText}</p> : infoText}
        <button
          type="button"
          className="closeInfoContent"
          onClick={() => hideInfo()}
          style={{ display: 'block', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          aria-label={ariaLabelHide || "Fermer"}
        ></button>
      </div>
    </div>
  );
};

export default InfoContent;